export const TITLES = {
  USER_PAGE_TITLE: "User View",
  APPROVAL_STATUS: "Approval Status",
  ROLE: "Role",
  EMPLOYMENT_STATUS: "Employment Status",
};

export const MESSAGES = {
  NO_USER_DATA: "Users Data Not Available",
  USER_DATA_FETCH: "Users data fetched successfully!",
  USER_DATA_ERROR: "Failed to fetch user data!",
  CHANGES_SAVED: "Changes Saved",
  CHANGES_SAVED_ERROR: "Failed to save changes!",
  USERS_LOAD_FAILED: "Failed to load users!",
  USER_UPDATE_SUCCESS: "User Updated Successfully!",
  USER_UPDATE_FAILED: "Failed to update user!",
  UPDATE_ERROR: "Error occurred while updating!",
  PROFILE_UPDATE_FAILED: "Failed to update profile!",
  PROFILE_UPDATE_SUCCESS: "Profile updated successfully!",
  FAILED_FETCH_ACCOUNT_INFO: "Failed to fetch account info!",
  ACCOUNT_INFO_UPDATE_SUCCESS: "Account info updated successfully!",
  ACCOUNT_INFO_UPDATE_FAILED: "Failed to update account info!",
  USER_ONBOARDING_CONFIRMED: "User Onboarding Confirmed Successfully!",
  USER_ONBOARDING_CONFIRMATION_FAILED: "Failed to confirm user onboarding!",
  FAILED_TO_FETCH_DOCUMENTS: "Failed to fetch documents!",
  DOCUMENT_STATUS_UPDATE_SUCCESS: "Document Status Updated Successfully!",
  DOCUMENT_STATUS_UPDATE_FAILED: "Failed to update document status!",
  DOCUMENT_UPLOAD_SUCCESS: "Document Uploaded Successfully!",
  DOCUMENT_UPLOAD_FAILED: "Failed to Upload Document!",
  USER_ID_MISSING: "User ID is missing",
  PASSWORD_RESET_SUCCESS:"Password reset successful",
  PASSWORD_RESET_FAILDED:"Failed to reset password",
  SITES_LOAD_FAILED: "Failed to load assigned sites",
};

export const VALIDATION_MESSAGES = {
  ROLE_REQUIRED: "Role is required",
  APPROVAL_STATUS_REQUIRED: "Approval status is required",
  FIRST_NAME_REQUIRED: "First name is required",
  LAST_NAME_REQUIRED: "Last name is required",
  GENDER_REQUIRED: "Gender is required",
  INVALID_MAIL: "Invalid email address",
  MAIL_REQUIRED: "Email is required",
  SALARY_ACC_NO_REQUIRED: "Account number is required",
  IFSC_CODE_REQUIRED: "Bank IFSC code is required",
  bank_name: "Bank Name is required",
  uan_number: "UAN Number is required",
  birth_date: "Birth Date is required",
  current_address: "Current Address is required",
  permanent_address: "Permanent Address is required",
  emergency_contact_number: "Emergency Contact is required",
  emergency_contact_number_digits: "Emergency contact number must be exactly 10 digits",
  education: "Education Details are required",
  joining_date: "Joining date is required",
  designation: "Designation is required",
  pan_number: "PAN must be in the format ABCDE1234F",
  aadhar_number: "Aadhar number must be exactly 12 digits",
};

export const USER_TABLE_COLUMNS = [
  "first_name",
  "last_name",
  "company",
  "mobile",
  "role",
  "is_approved",
  "employment_status",
  "actions",
];

export const USER_COLUMN_LABELS = {
  first_name: "First Name",
  last_name: "Last Name",
  company: "Company",
  mobile: "Mobile Number",
  role: "User Role",
  is_approved: "Approval Status",
  employment_status: "Employment Status",
  actions: "Actions",
};

export const COMPANY_FIELDS = [
  { label: "TechB Energy LLP", value: "TECHB_ENERGY" },
  { label: "TechB Softwares LLP", value: "TECHB_SOFTWARES" },
];

export const ROLE_FIELDS = [
  { label: "Admin", value: "ADMIN" },
  { label: "Project Incharge", value: "PROJECT_INCHARGE" },
  { label: "Site Incharge", value: "INCHARGE" },
  { label: "Site Staff", value: "SITESTAFF" },
  { label: "Human Resource", value: "HR" },
  { label: "Director Management", value: "DIRECTOR_MANAGEMENT" },
  { label: "Accounts", value: "ACCOUNTS" },
];

export const ROLE_FIELDS_CLASSNAME = [
  { label: "Admin", value: "ADMIN", className: "bg-blue-100 text-blue-700" },
  { label: "Project Incharge", value: "PROJECT_INCHARGE", className: "bg-green-100 text-green-700" },
  { label: "Site Incharge", value: "INCHARGE", className: "bg-yellow-100 text-yellow-700" },
  { label: "Site Staff", value: "SITESTAFF", className: "bg-purple-100 text-purple-700" },
  { label: "Human Resource", value: "HR", className: "bg-orange-100 text-orange-700" },
  { label: "Director Management", value: "DIRECTOR_MANAGEMENT", className: "bg-indigo-100 text-indigo-700" },
  { label: "Accounts", value: "ACCOUNTS", className: "bg-pink-100 text-pink-700" },
];

export const APPROVAL_FIELDS = [
  { label: "Approved", value: "true" },
  { label: "Not Approved", value: "false" },
];

export const EMPLOYMENT_STATUS_FIELDS = [
  { label: "Pending Onboarding", value: "PENDING_ONBOARDING" },
  { label: "Onboarded", value: "ONBOARDED" },
  { label: "Off-boarded", value: "OFFBOARDED" },
];

export const USER_TABS = [
  { key: "USER_INFO", label: "User Info" },
  { key: "ACCOUNT_INFO", label: "Account Info" },
  { key: "DOCUMENTS", label: "Documents" },
];

export const USER_TAB_KEYS = {
  USER_INFO: "USER_INFO",
  ACCOUNT_INFO: "ACCOUNT_INFO",
  DOCUMENTS: "DOCUMENTS",
};

export const PROFILE_TABS = [
  { key: USER_TAB_KEYS.USER_INFO, label: "User Info" },
  { key: USER_TAB_KEYS.DOCUMENTS, label: "Documents" },
];

export const USERS_TAB = [
  { key: USER_TAB_KEYS.USER_INFO, label: "User Info" },
  { key: USER_TAB_KEYS.ACCOUNT_INFO, label: "Account Info" },
  { key: USER_TAB_KEYS.DOCUMENTS, label: "Documents" },
];